import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  MuiAccordionroot: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    marginBottom: '8px',
    transition: 'all 0.3s ease',
    border: 'none',
    borderRadius: '0',
     borderBottom: '1px solid rgba(4, 103, 156, 0.2)',
    '&:before': {
      display: 'none',
    },
    
    '&:not(.Mui-expanded):hover': {
      '& $root': {
        backgroundColor: 'rgba(245, 245, 245, 0.5)',
      }
    },
    
    '&.Mui-expanded:hover': {
      backgroundColor: 'rgba(245, 245, 245, 0.5)',
      
      '& $root, & $MuiAccordionDetails-root': {
        backgroundColor: 'transparent !important', 
      }
    },
    
    '&.Mui-expanded': {
      margin: '8px 0 !important',
      backgroundColor: theme.palette.action.selected,
      borderBottom: 'none',
      boxShadow: theme.shadows[2],
    },
  },

  root: {
    minHeight: '72px',
    padding: '0 32px',
    transition: 'all 0.3s ease',
    
    '&.Mui-expanded': {
      minHeight: '72px',
      backgroundColor: theme.palette.action.selected,
    },
  },

  MuiAccordionDetails: {
    padding: '16px 32px',
    transition: 'background-color 0.3s ease',
    backgroundColor: theme.palette.action.selected,
  },

  questions: {
    fontWeight: 500,
    fontFamily: 'Montserrat',
    color: theme.palette.text.primary,
    fontSize: '18px',
    lineHeight: '1.4',
    letterSpacing: '-0.2px',
    margin: 0,
  },

  answers: {
    fontWeight: 400,
    textAlign:'left',
    fontFamily: 'Montserrat',
    color: theme.palette.text.secondary,
    fontSize: '16px',
    lineHeight: '1.6',
    padding: '8px 0',
    
    '& ul': {
      paddingLeft: '24px',
      margin: '8px 0',
    },
    
    '& li': {
      marginBottom: '8px',
      position: 'relative',
      
      '&::before': {
        content: '"•"',
        color: '#06E89F',
        fontWeight: 'bold',
        display: 'inline-block',
        width: '1em',
        marginLeft: '-1em',
        position: 'absolute',
      }
    },
    
    '& a': {
      color: '#06E89F',
      textDecoration: 'none',
      fontWeight: 500,
      borderBottom: '1px solid rgba(6, 232, 159, 0.3)',
      
      '&:hover': {
        color: '#04C586',
        borderBottom: '1px solid #04C586',
      },
    },
  },

  removeCircleOutlineIcon: {
    color: '#06E89F',
    fontSize: '1.8rem !important',
    transition: 'all 0.3s ease',
    opacity: 0.9,
    
    '&:hover': {
      opacity: 1,
      transform: 'scale(1.1)',
    },
  },

  addCircleOutlineIcon: {
    color: '#06E89F',
    fontSize: '1.8rem !important',
    transition: 'all 0.3s ease',
    opacity: 0.7,
    
    '&:hover': {
      opacity: 0.9,
      transform: 'scale(1.1)',
    },
  },

  '@media (max-width: 768px)': {
    root: {
      padding: '0 24px',
      minHeight: '64px',
    },
    
    MuiAccordionDetails: {
      padding: '12px 24px',
    },
    
    questions: {
      fontSize: '17px',
    },
    
    answers: {
      fontSize: '15px',
    },
  },
}));

export default useStyles;
